import { render, staticRenderFns } from "./TestCardList.vue?vue&type=template&id=3c348f20&"
import script from "./TestCardList.vue?vue&type=script&lang=js&"
export * from "./TestCardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports